/*
 *  I10DIAMPUISSCalcul.js
 *
 *  Created by Sébastien Hecart on 2017-12-16 16:56:09 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

import { fetchMasseVolumiqueViscosite, fetchPerteChargeUnite, fetchTubeHydrauliqueDiametreSuperieur } from '@batical/data/src'
import { RMasseVolumiqueViscosite_Type, RPerteChargeUniteCalculSchema_Type, I10DIAMPUISS_State } from '@batical/types/src'

import { nombreReynolds } from '../CommonFormula'

function I10DIAMPUISS_docalcul(state: I10DIAMPUISS_State, isWeb = false) {
  const previousDebit = state.res_debitReel

  state.invalidated = false
  let selectedviscosite_uuid: RMasseVolumiqueViscosite_Type = fetchMasseVolumiqueViscosite(state.viscosite_uuid)
  let selectedperteCharg_uuid: RPerteChargeUniteCalculSchema_Type = fetchPerteChargeUnite(state.perteCharg_uuid)
  let in_debit = state.in_puissance / (1.16 * state.in_delatTemp)
  let diametreInterieur = Math.sqrt((in_debit * 353.68) / state.in_vitesse)
  if (isFinite(diametreInterieur)) {
    state.res_vMax = Math.sqrt(diametreInterieur / 50)
    let selectedTube = fetchTubeHydrauliqueDiametreSuperieur(diametreInterieur, state.material_uuid)
    if (selectedTube === null) {
      state.tube_uuid = ''
      state.res_perteChargeResultat = 0
    } else {
      state.res_debitReel = state.in_puissance / state.in_delatTemp / 1.16
      state.tube_uuid = selectedTube.uuid
      let res_nbrReynolds = nombreReynolds(
        in_debit,
        selectedTube.diamInt,
        selectedviscosite_uuid.viscositeKgms * selectedviscosite_uuid.masseVolumique
      )

      let res_facPerteCharge: number = 0
      res_facPerteCharge = 0
      state.res_perteChargeResultat = 0
      if (res_nbrReynolds < 3000) {
        res_facPerteCharge = 64 / res_nbrReynolds
        //  res_typeRegime = "Transitoire"
      } else if (res_nbrReynolds < 10e11) {
        let step3 = selectedTube.rugositeMax / (selectedTube.diamInt * 3.7)
        var tpfci = 0.0
        var tpfc = 0.1 / ((3.7 * 263.1) / 1000)
        while (Math.abs(tpfc - tpfci) > 1e-6) {
          tpfci = tpfc
          tpfc = Math.pow(-1 / (2 * Math.log10(2.51 / (res_nbrReynolds * Math.sqrt(tpfci)) + step3)), 2)
        }
        res_facPerteCharge = tpfc
      }

      if (res_nbrReynolds < 10e11) {
        const vitesseReel = (4 * (state.res_debitReel / 3600)) / (Math.PI * Math.pow(selectedTube.diamInt / 1000, 2))
        state.res_perteChargeResultat =
          (((res_facPerteCharge / (selectedTube.diamInt / 1000)) * selectedviscosite_uuid.masseVolumique * Math.pow(vitesseReel, 2)) / 2) *
          selectedperteCharg_uuid.factor
      }
      // state.res_puissanceReel = Math.pow(selectedTube.diamInt, 2) * state.in_vitesse * state.in_delatTemp * 1.16 / 353.68;
    }
  }

  if (isWeb) {
    let dataChart = []
    if (state.material_uuid != null) {
      for (let i = 3; i <= 35; i++) {
        const dn: number = Math.sqrt((state.res_debitReel * 353.68) / (i / 10))

        if (i % 2 !== 0) {
          const tube = fetchTubeHydrauliqueDiametreSuperieur(dn, state.material_uuid)
          if (tube != null) {
            var color = '#d3d3d3'
            if (i > 15) {
              color = 'rgba(220,50, 50,1)'
            }
            dataChart.push({ Vitesse: String(i / 10), DN: tube.diamInt, color: color, l1: dn })
          }
        }
        // dataChart.push({Vitesse : 3.6, "Dn Calculé": dn, "Dn trouvé", tube.diamInt,  color: color})
      }
    }
    state.dataChart = dataChart
  } else {
    if (
      state.material_uuid != null &&
      !(
        state.preivousMat != null &&
        state.material_uuid === state.preivousMat &&
        previousDebit === state.res_debitReel &&
        state.dataLine !== null
      )
    ) {
      state.preivousMat = state.material_uuid
      let dataLine = []
      let dataBar = []
      for (let i = 3; i <= 35; i++) {
        const dn: number = Math.sqrt((state.res_debitReel * 353.68) / (i / 10))

        if (i % 2 !== 0) {
          const tube = fetchTubeHydrauliqueDiametreSuperieur(dn, state.material_uuid)
          if (tube != null) {
            // minimumDN = Math.min(minimumDN, dn);
            // maximumDN = Math.max(maximumDN, dn);
            // minimumSpeed = Math.min(minimumSpeed, i / 10);
            // maximumSpeed = Math.max(maximumSpeed, i / 10);
            let color2 = '#d3d3d3'
            if (i > 15) {
              color = 'rgba(220,50, 50,1)'
            }
            dataLine.push({ x: i / 10, y: dn })
            dataBar.push({ x: i / 10, y: tube.diamInt, fill: color2 })
          }
        }
        dataLine.push({ x: 36 / 10, y: Math.sqrt((state.res_debitReel * 353.68) / (36 / 10)) })
      }
      state.dataLine = dataLine
      state.dataBar = dataBar
    }
  }
  return state
}

export default I10DIAMPUISS_docalcul
